import API from '../../sunwiseAPI';
const ENTITY = 'politicals-divisions';

export const getItemsByLevel = (str, companyId) =>
    API.get(`/api/v1/${ENTITY}/level/${str}/public/`, {
        params: { company: companyId },
    });
export const getItemsByParent = (id, companyId) =>
    API.get(`/api/v1/${ENTITY}/parent/${id}/public/`, {
        params: { company: companyId },
    });
export const getLocationsByZipCode = (zipCode) =>
    API.get(`/api/v1/locations-by-zip-code/${zipCode}/public/`);
